import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Variable reward:", -1)
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Fixed reward:", -1)
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Promised schedule:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedScheduleDisplay = _resolveComponent("FixedScheduleDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, "Accrued reward: " + _toDisplayString(_ctx.reward.accruedReward), 1),
    _createElementVNode("div", _hoisted_4, "Paid out reward: " + _toDisplayString(_ctx.reward.paidOutReward), 1),
    (_ctx.parseRewardType(_ctx.farmReward) === 'variable')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, " Last recorded accrued reward per gem: " + _toDisplayString(_ctx.numeral(
            _ctx.reward.variableRate.lastRecordedAccruedRewardPerRarityPoint.n / 10 ** 15
          ).format('0,0.0')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, " Staking begins: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.beginStakingTs)), 1),
          _createElementVNode("div", _hoisted_11, " Schedule begins: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.beginScheduleTs)), 1),
          _createElementVNode("div", _hoisted_12, " Last updated: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.lastUpdatedTs)), 1),
          _createElementVNode("div", _hoisted_13, " Promised duration: " + _toDisplayString(_ctx.reward.fixedRate.promisedDuration), 1),
          _hoisted_14,
          _createVNode(_component_FixedScheduleDisplay, {
            key: _ctx.farmReward,
            class: "ml-5",
            schedule: _ctx.reward.fixedRate.promisedSchedule
          }, null, 8, ["schedule"])
        ]))
  ]))
}